/**
 * Redux Store Configuration for Public Websearch Chatbot Client
 *
 * Configures RTK Query store with feedback API slice and feedback state management.
 */

import { configureStore } from '@reduxjs/toolkit';
import { feedbackApi } from './api/feedbackApi';
import feedbackReducer from './slices/feedbackSlice';

/**
 * Configure Redux store with RTK Query API slices
 */
export const store = configureStore({
  reducer: {
    // Add RTK Query API slices
    [feedbackApi.reducerPath]: feedbackApi.reducer,

    // Add regular slices
    feedback: feedbackReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Configure serializable check to handle RTK Query actions
      serializableCheck: {
        ignoredActions: [
          // Ignore RTK Query action types
          'persist/PERSIST',
          'persist/REHYDRATE',
        ],
      },
    })
      // Add RTK Query middleware
      .concat(feedbackApi.middleware),

  // Enable Redux DevTools in development
  devTools: process.env.NODE_ENV !== 'production',
});

// Infer RootState and AppDispatch types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export store as default
export default store;
